@if (tableReady) {
    <table [dataSource]="visiblePermissions" class="mat-elevation-z0 responsiveTable" mat-table
           [class.massiveTable]="this.currentUser.role.role_type=='admin'">
        <ng-container matColumnDef="profile">
            <th *matHeaderCellDef mat-header-cell> Profile</th>
            <td *matCellDef="let permission" mat-cell>
                @if (permission.user) {
                    @if (currentUser.role.role_type == 'admin' || (currentUser.role.can_access_profiles && permission.user.id != child)) {
                        <button (click)="viewProfile(permission)"
                                [attr.aria-label]="'View profile of ' + (permission.user| nameDisplay: undefined: undefined: this.isProfile? 'profile': undefined )"
                                [matTooltip]="'View ' +  (permission.user| nameDisplay: undefined: undefined: this.isProfile? 'profile': undefined ) + '\'s Profile'"
                                class="avatarAction p-0" type="button">
                            @if (permission.user?.thumbnail || permission.user?.photo) {
                                <img [alt]="permission.user| nameDisplay: undefined: undefined: this.isProfile? 'profile': undefined "
                                     [src]="permission.user?.thumbnail || permission.user?.photo|| 'assets/images/blankProfile.png'"
                                     class="w-100 userImg" fetchPriority="low" loading="lazy">
                            } @else {
                                <p class="initial m-10">{{ permission.user.first_name | slice: 0 : 1 }} {{ permission.user.last_name | slice: 0 : 1 }}</p>
                            }
                        </button>
                    } @else {
                        <div [matTooltip]="(permission.user| nameDisplay: undefined: undefined: this.isProfile? 'profile': undefined ) + '\'s Profile Picture'"
                             class="p-0">
                            @if (permission.user?.thumbnail || permission.user?.photo) {
                                <img [alt]="permission.user| nameDisplay: undefined: undefined: this.isProfile? 'profile': undefined "
                                     [src]="permission.user?.thumbnail || permission.user?.photo|| 'assets/images/blankProfile.png'"
                                     class="w-100 userImg" fetchPriority="low" loading="lazy">
                            } @else {
                                <p class="initial m-10">{{ permission.user.first_name | slice: 0 : 1 }} {{ permission.user.last_name | slice: 0 : 1 }}</p>
                            }
                        </div>
                    }
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th *matHeaderCellDef mat-header-cell> Name</th>
            <td *matCellDef="let permission" mat-cell><b
                    class="d-none columnTitle">Name:</b>
                <div class="flex-col d-flex">
                    <p class="m-0">{{ permission.user| nameDisplay: undefined: undefined: this.isProfile ? 'profile' : undefined }}</p>
                    @if (showOwnerColumn && permission?.is_owner === true) {
                        <div class="pt-5">
                            <mat-chip class="m-0">Memory Box Owner</mat-chip>
                        </div>
                    }
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="role">
            <th *matHeaderCellDef mat-header-cell>User Role</th>
            <td *matCellDef="let permission" mat-cell>
                <b class="d-none columnTitle">User Role:</b>
                @if (permission.user?.role?.name) {
                    {{ permission.user?.role?.name | removeBrackets }}
                }
                @if (permission.user?.role.length > 0) {
                    {{ permission.user?.role | removeBrackets }}
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="relationship">
            <th *matHeaderCellDef mat-header-cell>
                <div class="flex-row d-flex align-items-center gap-5">
                    Relationship to {{ this.firstName || this.timelineName }}
                    <button class="p-0 infoBtn" disableRipple
                            aria-label="This field is for reference only and does not alter the behaviour of the permission"
                            mat-icon-button matSuffix
                            matTooltip="This field is for reference only and does not alter the behaviour of the permission">
                        <mat-icon>info</mat-icon>
                    </button>
                </div>
            </th>
            <td *matCellDef="let permission" mat-cell>
                @if (this.currentUser.role.role_type == 'admin') {
                    <mat-form-field appearance="outline" class="w-100 mt-10">
                        <mat-label>Relationship</mat-label>
                        <input [(ngModel)]="permission.newName" [readonly]="permission.loading" matInput type="text">
                        <button (click)="editRelationshipName(permission)"
                                [disabled]="permission.loading || permission.newName == permission.name "
                                aria-label="Save"
                                color="primary"
                                mat-icon-button
                                matIconSuffix matTooltip="Save new relationship name">
                            @if (permission.loading) {
                                <mat-icon>
                                    <mat-spinner color="primary"></mat-spinner>
                                </mat-icon>
                            } @else {
                                <mat-icon>save</mat-icon>
                            }
                        </button>
                    </mat-form-field>
                } @else {
                    <b class="d-none columnTitle">Relationship:</b>
                    {{ permission.name }}
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="access">
            <th *matHeaderCellDef mat-header-cell>
                <div class="flex-row d-flex align-items-center gap-5">
                    Direct Contact
                    <button class="p-0 infoBtn" disableRipple
                            aria-label="This field is for reporting only and does not alter the behaviour of the permission"
                            mat-icon-button matSuffix
                            matTooltip="This field is for reporting only and does not alter the behaviour of the permission">
                        <mat-icon>info</mat-icon>
                    </button>
                </div>
            </th>
            <td *matCellDef="let permission" mat-cell>
                @if (this.currentUser.role.role_type == 'admin') {
                    <b class="d-none columnTitle"> Direct Contact:</b>
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <mat-checkbox [(ngModel)]="permission.is_direct" color="accent"
                                      (ngModelChange)="editRelationshipAccess(permission)"
                                      [aria-label]="'Update Contact to ' + permission.is_direct? 'Indirect' : 'Direct'"></mat-checkbox>
                    </div>
                } @else {
                    <b class="d-none columnTitle">Contact:</b>
                    {{ permission.is_direct ? 'Direct' : 'In-Direct' }}
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="permission">
            <th *matHeaderCellDef mat-header-cell> Permission</th>
            <td *matCellDef="let permission" mat-cell>

                @if (this.canRequest && canChangePermission(permission.user)) {
                    <mat-form-field appearance="outline" class=" w-100 pt-10 noPaddingBottom" color="primary">
                        <mat-label>Permission</mat-label>
                        <mat-select [(value)]="permission.newPermission" [value]="permission.permission">
                            @for (permission of permissionOptions; track permission) {
                                <mat-option [value]="permission.value">{{ permission.name| permissionsDisplay | async }}
                                </mat-option>
                            }
                        </mat-select>
                        @if ((permission.newPermission && permission.newPermission != permission.permission) && (this.currentUser.role.role_type == 'admin' || this.currentUser.role.can_edit_permissions)) {
                            <button (click)="requestPermissionUpdate(permission)"
                                    [disabled]="!permission.newPermission || permission.permission == permission.newPermission"
                                    aria-label="Save"
                                    color="primary"
                                    mat-icon-button
                                    matIconSuffix matTooltip="Update Permission">
                                @if (permission.loading) {
                                    <mat-icon>
                                        <mat-spinner color="primary"></mat-spinner>
                                    </mat-icon>
                                } @else {
                                    <mat-icon>save</mat-icon>
                                }
                            </button>
                        } @else if (this.currentUser.role.role_type == 'admin' && this.isRaa) {
                            <button (click)="revokeAccess(permission)"
                                    aria-label="Revoke Access"
                                    color="warn"
                                    mat-icon-button
                                    matIconSuffix matTooltip="Revoke Access">
                                @if (permission.loading) {
                                    <mat-icon>
                                        <mat-spinner color="primary"></mat-spinner>
                                    </mat-icon>
                                } @else {
                                    <mat-icon>close</mat-icon>
                                }
                            </button>
                        }
                    </mat-form-field>
                    <mat-form-field
                            [class.hidden]="permission.newPermission == permission.permission || !permission.newPermission || this.currentUser.role.role_type == 'admin' || this.currentUser.role.can_edit_permissions"
                            appearance="outline" class="w-100">
                        <mat-label>Permission Change Request Description</mat-label>
                        <textarea #description [(ngModel)]="permission.changeRequest"
                                  [ngModelOptions]="{standalone: true}"
                                  matInput
                                  maxlength="400"></textarea>
                        <mat-hint align="end">{{ description?.value?.length }} / 400</mat-hint>
                    </mat-form-field>
                    @if (permission.newPermission && permission.newPermission != permission.permission && !(this.currentUser.role.role_type == 'admin' || this.currentUser.role.can_edit_permissions)) {
                        <button (click)="requestPermissionUpdate(permission)"
                                [disabled]="!permission.newPermission || permission.permission == permission.newPermission"
                                class="mb-10"
                                color="primary"
                                mat-raised-button>
                            Send Permission Update Request
                        </button>
                    }
                } @else {
                    <div class="d-flex flex-row align-items-center">
                        {{ permission?.permission| permissionsDisplay | async }}
                        @if (this.currentUser.role.role_type == 'admin' && this.isRaa) {
                            <button (click)="revokeAccess(permission)"
                                    aria-label="Revoke Access"
                                    color="warn"
                                    mat-icon-button
                                    class="p-0 m-0"
                                    matIconSuffix matTooltip="Revoke Access">
                                @if (permission.loading) {
                                    <mat-icon>
                                        <mat-spinner color="primary"></mat-spinner>
                                    </mat-icon>
                                } @else {
                                    <mat-icon>close</mat-icon>
                                }
                            </button>
                        }
                    </div>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="uploadSession">
            <th *matHeaderCellDef mat-header-cell>Upload Frequency</th>
            <td *matCellDef="let permission" mat-cell>

                @if (shouldShowUploadFrequency(permission)) {
                    @if (this.myMemoryBox && permission.user.role?.raa_is_limited && this.child != permission?.user?.id) {
                        <!--       Looking at access they have so need to check their access        -->
                        <button (click)="openUploadSession(permission)" color="primary"
                                mat-raised-button>Edit
                        </button>
                    } @else if (!this.myMemoryBox && this.childProfile?.role?.raa_is_limited && this.child != permission?.user?.id) {
                        <!--      Looking at access i have so need to check my access        -->
                                <!--       Hide if its me -->
                        <button (click)="openUploadSession(permission)" color="primary"
                                mat-raised-button>Edit
                        </button>
                    } @else {
                        Unlimited
                    }
                } @else {
                    No Upload
                }
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
} @else if (configurationError()) {
    <p>Could not load access settings.</p>
    <button (click)="loadConfiguration()" color="primary" mat-raised-button>Retry</button>
} @else {
    <div class="d-flex align-items-center gap-10" role="status">
        <mat-progress-spinner aria-label="Loading access settings" [diameter]="24"
                              mode="indeterminate"></mat-progress-spinner>
        Loading access settings…
    </div>
}
